import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Icon } from 'uikit/icons';
import { Typo } from 'uikit/content';

import styles from '../styles/learningObjectivesLearnerList.module.scss';

// ** NOTICE ** //
// ** PLEASE ALSO UPDATE app/views/student/learning_objectives/_list.html.erb ** //
// ** NOTICE ** //

const LearningObjectivesLearnerList = ({ className, title, learningObjectives }) => (
  <div className={classnames(className, styles.element)}>
    <div className={styles.header}>
      <Icon size={18} className={styles.icon} icon="bulb" />
      <Typo element="h2" variant="d01" weight="medium">
        {title}
      </Typo>
    </div>
    <ul className={styles.list}>
      {learningObjectives.map((objective) => (
        <li className={styles.listItem} key={objective.id}>
          <Typo element="p" variant="b02" className={styles.text}>
            {objective.content}
          </Typo>
        </li>
      ))}
    </ul>
  </div>
);

LearningObjectivesLearnerList.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  learningObjectives: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      content: PropTypes.string,
    }),
  ).isRequired,
};

export default React.memo(LearningObjectivesLearnerList);
